import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  VERSION,
} from "@angular/core";
import { LmsService } from "../../_Lms/services/lms.service";
import { LosService } from "../../_LOS/services/los.service";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";
import { MasterService } from "src/app/Shared/app.Masters.Service";
declare var $: any;
@Component({
  selector: "app-quickloan-cibil-surepass",
  templateUrl: "./quickloan-cibil-surepass.component.html",
  styleUrls: ["./quickloan-cibil-surepass.component.scss"],
})
export class QuickloanCibilSurepassComponent implements OnInit {
  showSpinner: boolean = false;
  CibilDataSurePass: any;
  ApplicationDetail: any;
  PurposeList: any[] = [];
  SuitFiled: any[] = [];
  CreditFacilityStatus: any[] = [];
  foundItem: any;
  CibilAcore_List: any[] = [];
  @Input() cibilResponseSurePass: any;
  OpenWindow: Window;

  //@ViewChild('TransUnionCIBIL') TransUnionCIBIL!: ElementRef;

  constructor(
    private losService: LosService,
    private lmsService: LmsService,
    private _commonfunctions: CommonFunctions,
    private _MasterService: MasterService
  ) {}

  ngOnInit(): void {
    let ele = document.getElementById("headerId");
    ele.style.display = "none";
    let ele1 = document.getElementById("footerId");
    ele1.style.display = "none";
    this.losService
      .GET_CRC_MASTER_BY_CRCAGENCY({
        Crc_Agency: "1",
        Is_Firm: 0,
      })
      .subscribe((res: any) => {
        this.PurposeList = res;
        console.log("Purpose list", this.PurposeList);
      });

    this.getCommonMasterForSuitFiled();
    this.getCommonMasterForCreditFacilityStatus();

    this.losService.Get_Master_CibilAcore_List().subscribe((res: any) => {
      this.CibilAcore_List = res;
    });
    this.getCibilReports();
  }
  findItemById(code): void {
    if (this.PurposeList.find((item) => item.Code === code)) {
      return this.PurposeList.find((item) => item.Code === code).Value;
    } else null;
  }
  getCommonMasterForSuitFiled() {
    this._MasterService
      .GetCommonMaster_FOR_DROPDOWN({ Type: "SUIT FILED STATUS" })
      .subscribe((res: any) => {
        this.SuitFiled = res;
        console.log("this.SuitFiled", this.SuitFiled);
      });
  }

  getCommonMasterForCreditFacilityStatus() {
    this._MasterService
      .GetCommonMaster_FOR_DROPDOWN({ Type: "WO AND SETTLED STATUS" })
      .subscribe((res: any) => {
        this.CreditFacilityStatus = res;
        console.log("this.CreditFacilityStatus", this.CreditFacilityStatus);
      });
  }

  getCibilReports() {
    this.showSpinner = true;
    // this.lmsService.Get_Lms_CIBILReports().subscribe((result) => {
    // console.log("Cibil Data", result);
    this.CibilDataSurePass = this.cibilResponseSurePass;
    console.log("Cibil Data", this.CibilDataSurePass);

    this.showSpinner = false;
    if (this.CibilDataSurePass?.data.credit_report[0]?.accounts != undefined) {
      this.CibilDataSurePass ?.data.credit_report[0]?.accounts.forEach((obj) => {
        obj.payment = [];
        obj.paymentDate = [];
        obj.onedue = [];
        obj.twodue = [];
        obj.threedue = [];
        var payDate = Object.assign(new Date(obj.paymentStartDate));
        payDate.setMonth(payDate.getMonth());
       
        for (let i = 0; i < obj.paymentHistory.length; i += 3) {
          obj.payment.push(obj.paymentHistory.slice(i, i + 3));
        }
        for (let i = 0; i < obj.payment.length; i++) {
          const date = new Date(Object.assign(new Date(obj.paymentStartDate)));
          date.setMonth(payDate.getMonth() - i);
         // date.setFullYear(payDate.getFullYear());
          obj.paymentDate.push(this.formatMonthYear(date));
        }
        for (let i = 0; i < 15; i++) {
          obj.onedue.push({ score: obj.payment[i], sDate: obj.paymentDate[i] });
        }
        if (obj.payment.length > 15) {
          for (let i = 15; i < 30; i++) {
            obj.twodue.push({
              score: obj.payment[i],
              sDate: obj.paymentDate[i],
            });
          }
        }
        if (obj.payment.length > 30) {
          for (let i = 30; i < obj.payment.length; i++) {
            obj.threedue.push({
              score: obj.payment[i],
              sDate: obj.paymentDate[i],
            });
          }
        }
      });
      console.log("accouts", this.CibilDataSurePass?.data.credit_report[0]?.accounts);
    }
  }
  formatMonthYear(date: Date): string {
    const month = date.getMonth();
    const year = date.getFullYear();
    return `${(month == 0
        ? "12"
        : month < 10
          ? "0" + month.toString()
          : month.toString()) +
      "-" +
      (month == 0
        ? (year - 1).toString().substring(4, 2)
        : year.toString().substring(4, 2))
      }`;
  }
  findCibilScore(code, scoreName): void {
    //console.log("score", this.CibilAcore_List.find(item => item.Code === code && item.ScoreName === scoreName))
    if (
      this.CibilAcore_List.find(
        (item) => item.Code === code && item.ScoreName === scoreName
      )
    ) {
      return this.CibilAcore_List.find(
        (item) => item.Code === code && item.ScoreName === scoreName
      ).Explanation;
    } else return null;
  }
  convertToDate(mmddyyyy: string): Date {
    const year = parseInt(mmddyyyy.substring(0, 4));
    const month = parseInt(mmddyyyy.substring(4, 6)); // Months are zero-based in JavaScript
    const day = parseInt(mmddyyyy.substring(6, 8));
    console.log("new Date", new Date(year, month, day))
    return new Date(year, month, day);
  }
  onDocsPrint(divName) {
    //var prtContent = document.getElementById(divName);
    //var WinPrint = window.open('', '_blank');
    //WinPrint.document.write(prtContent.innerHTML);
    //WinPrint.document.close();
    //WinPrint.focus();
    //WinPrint.print();
    this._commonfunctions.PrintCibil(divName, "Cibil", new Date().getTime());
    //let printContents = this.TransUnionCIBIL.nativeElement.innerHTML;
    //let originalContents = document.body.innerHTML;

    //document.body.innerHTML = printContents;

    //window.print();

    //document.body.innerHTML = originalContents;
  }

  onCloseCibilReport() {
    $("#cibilReportSurePass").modal("hide");
  }
   findCreditFacilityStatusByiD(code) {
    if (code == null || code === undefined) {
      return null;
    }
    const result = this.CreditFacilityStatus.find((item) => item.Code === code);
    return result ? result.Value : null;
  }
}
